import React, { useState } from 'react';
// ¡Ahora sí los usaremos!
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from '../config/firebase.js'; // Importamos nuestra instancia de auth

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Por favor, ingresa correo y contraseña.');
      return;
    }
    
    try {
      // Esta es la llamada real a Firebase.
      // Intenta iniciar sesión con el correo y la contraseña proporcionados.
      await signInWithEmailAndPassword(auth, email, password);
      
      // Si el login es exitoso, NO necesitamos hacer nada más aquí.
      // El "espía" que pusimos en App.js (onAuthStateChanged) se dará cuenta
      // automáticamente y nos cambiará al Dashboard.
      
    } catch (err) {
      // Si Firebase devuelve un error (ej. contraseña incorrecta), lo mostramos.
      console.error("Error de autenticación:", err.code);
      if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
        setError('El correo o la contraseña son incorrectos.');
      } else {
        setError('Ocurrió un error. Inténtalo de nuevo.');
      }
    }
  };

  // ... (el resto del código con los estilos permanece igual) ...
  // --- Estilos en línea para el diseño "Mission Control" ---
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#1a1a2e',
    color: '#ffffff',
    fontFamily: "'Orbitron', sans-serif",
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    padding: '40px',
    borderRadius: '10px',
    backgroundColor: '#162447',
    boxShadow: '0 0 25px rgba(27, 22, 98, 0.9)',
    border: '1px solid #0f3460',
    minWidth: '350px',
  };

  const inputStyle = {
    padding: '12px',
    borderRadius: '5px',
    border: '1px solid #e94560',
    backgroundColor: '#1f4068',
    color: '#ffffff',
    fontSize: '16px',
  };

  const buttonStyle = {
    padding: '12px',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: '#e94560',
    color: '#ffffff',
    fontSize: '16px',
    cursor: 'pointer',
    fontWeight: 'bold',
    transition: 'background-color 0.3s ease',
  };

  const titleStyle = {
    color: '#ffffff',
    marginBottom: '30px',
    textShadow: '0 0 10px #e94560, 0 0 20px #e94560',
  };

  return (
    <div style={containerStyle}>
      <h1 style={titleStyle}>HommeConnectPro - Mission Control</h1>
      <form onSubmit={handleLogin} style={formStyle}>
        <input
          type="email"
          placeholder="Correo Electrónico"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={inputStyle}
          aria-label="Correo Electrónico"
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={inputStyle}
          aria-label="Contraseña"
        />
        <button type="submit" style={buttonStyle}>
          Ingresar
        </button>
        {error && <p style={{ color: '#ff4757', marginTop: '10px' }}>{error}</p>}
      </form>
    </div>
  );
};

export default Login;